<template>
    <div @click="click($event)" class="calendar">
        <input class="present-input"
               type="text"
               :placeholder="placeholder"
               :disabled="disabledData"
               @focus="showPicker = true"
               v-model="inputValue" />
        <svg @click="openPicker()" width="18px" height="20px" class="calendar-icon">
            <use xlink:href="../../assets/images/sprite.svg#calendar"></use>
        </svg>

        <div v-show="showPicker" @click="closePicker()" class="bg-effect"></div>
        <div v-show="showPicker" class="date-picker">
            <div class="date-header multy">
                <div class="selected-date-wrap">
                    <div @click.prevent="$refs.firstInput.focus()" :class="['input-wrap mr-2',{'focus': focusFirst}]">
                        <input type="text"
                               ref="firstInput"
                               @focus="focusFirst = true"
                               @blur="focusFirst = false"
                               :placeholder="`${localizeList.departureDateUpper}:`">
                        <span class="selected-text">{{firstDate.text}}</span>
                        <div v-if="focusFirst && firstDate.text.length"
                             @mousedown="remove(0)"
                             class="clear-icon"></div>
                    </div>
                    <div v-if="direct !== 'oneway'" @click="$refs.secondInput.focus()" :class="['input-wrap',{'focus': focusSecond}]">
                        <input type="text"
                               ref="secondInput"
                               @focus="focusSecond = true"
                               @blur="focusSecond = false"
                               :placeholder="`${localizeList.arrivalDateUpper}:`">
                        <span class="selected-text">{{secondDate.text}}</span>
                        <div v-if="focusSecond && secondDate.text.length"
                             @mousedown="remove(1)"
                             class="clear-icon"></div>
                    </div>
                    <div v-else style="width: 100%"></div>
                </div>
            </div>

            <div class="date-body">
                <div class="date date-1">
                    <div class="date-slider">
                        <div v-if="!firstMonthSelected" @click="sldeDate('left')" class="date-slider-btn left-btn">
                            <svg width="9px" height="14px">
                                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                            </svg>
                        </div>
                        <div v-else class="date-slider-cap"></div>
                        <p class="date-month-year">
                            {{firstMonthYear}}
                        </p>
                    </div>

                    <div class="date-weeks">
                        <span v-for="(item, key) in weeks"
                              :key="key">
                            {{item}}
                        </span>
                    </div>

                    <div ref="firstMonth"
                         @mouseleave="unHover()"
                         class="date-month">
                        <div v-for="(item, key) in firstDaysCount"
                             :key="key"
                             @mouseover="hover(item, 1)"
                             @click="selectDay(item)"
                             :class="['date-day',{'active': item.isActive}, {'checked': item.isChecked}, {'fill': item.isFill}, isRound(firstDaysCount, key)]">
                            {{item.day}}
                        </div>
                    </div>

                </div>

                <div class="date date-2">
                    <div class="date-slider">
                        <p class="date-month-year">{{secondMonthYear}}</p>
                        <div @click="sldeDate('right')" class="date-slider-btn">
                            <svg width="9px" height="14px">
                                <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                            </svg>
                        </div>
                    </div>

                    <div class="date-weeks">
                        <span v-for="(item, key) in weeks"
                              :key="key">
                            {{item}}
                        </span>
                    </div>

                    <div ref="secondMonth"
                         @mouseleave="unHover()"
                         class="date-month">
                        <div v-for="(item, key) in secondDaysCount"
                             :key="key"
                             @mouseover="hover(item, 2)"
                             @click="selectDay(item, true)"
                             :class="['date-day',{'active': item.isActive}, {'checked': item.isChecked}, {'fill': item.isFill}, isRound(secondDaysCount, key)]">
                            {{item.day}}
                        </div>
                    </div>

                </div>
            </div>

            <div class="date-footer">
                <div class="align-center">
                    <checkbox v-model="daysChecked"></checkbox>
                    <p class="title mr-4">
                        +/-{{dayMode === 1 || dayMode === 2 ? localizeList.nights : localizeList.days}}
                    </p>
                    <base-select :items="daysCount"
                                 @toggle="selectShow = $event"
                                 v-model="selectedDay"></base-select>
                </div>
                <div class="align-center">
                    <base-button v-show="selectedDate.length"
                                 @click.native="clear()"
                                 background="var(--lighten-6-color)"
                                 class="mr-4"
                                 color="#727272">
                        {{localizeList.resetFlightsUpper}}
                    </base-button>
                    <base-button @click.native="done()"
                                 :disabled="disabledDone">
                        {{localizeList.applyUpper}}
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as typesGlobal from "@/stores/types";


    import moment from 'moment'
    import {bus} from '../../main.js'

    export default {
        name: "tickets-calendar",
        data() {
            return {
                firstDate: {
                    text: "",
                    value: "",
                },
                secondDate: {
                    text: "",
                    value: "",
                },
                showPicker: false,
                weeks: [],
                current: moment().format("YYYY-MM-DD"),
                firstMonthYear: "",
                firstMonthYearValue: "",
                secondMonthYear: "",
                dataDate: {
                    dates: []
                },
                selectedDate: [],
                daysCount: [],
                selectedDay: "",
                disabledData: false,
                inputValue: "",
                cash: {
                    dayFrom: "",
                    dayTo: "",
                },
                hoverDayFirst: null,
                hoverDaySecond: null,
                keyMove: {
                    position: null,
                    month: 1,
                    isShow: true
                },
                selectShow: false,
                daysChecked: false,
                focusFirst: false,
                focusSecond: false,
            }
        },
        props: {
            placeholder: {
                type: String
            },
            activeDates: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            },
            dayMode: {
                type: Number,
                default: 0
            },
            value: {
                type: Object,
                default: () => {}
            },
            maxDates: {
                type: Number,
                default: 0
            },
            maxDuration: {
                type: Number,
                default: 0
            },
            direct: {
                type: String,
                default: null
            }
        },
        created() {
            bus.$on("localizeCode", code => {
                code = code === "ua" ? "uk" : code
                moment.locale(code);
                this.disabledData = this.disabled;
                this.calendarMounted()
            })
        },
        mounted() {
            this.calendarMounted()
        },
        computed: {
            disabledDone() {
                let res = !this.firstDate.value.length || !this.secondDate.value.length;
                if (this.direct === "oneway"){
                    res = !this.firstDate.value.length
                }

                return res
            },
            firstMonthSelected(){
                const currentMonth = moment().month();
                const selectedMonth = new Date(this.current).getMonth()
                return currentMonth === selectedMonth
            },
            firstDaysCount() {
                let res         = [];
                let checkedDate = this.selectedDate.map(x => x.value);
                for (let i = 1; i <= moment(new Date(this.current)).daysInMonth(); i++) {
                    let dayConstuct = {
                        day: (i < 10 ? "0" + i : i),
                        isActive: false,
                        isChecked: false,
                        isFill: false,
                    }
                    if (checkedDate.includes(moment(new Date(this.current)).format("YYYY-MM-") + (i < 10 ? "0" + i : i))) {
                        dayConstuct.isChecked = true
                    }
                    if (this.activeDates.includes((i < 10 ? "0" + i : i) + moment(new Date(this.current)).format(".MM.YYYY")) || !this.activeDates.length) {
                        if (!this.activeDates.length) {
                            let currentDate   = moment(new Date()).format("YYYY-MM-DD");
                            let constructDate = moment(new Date(this.current)).format("YYYY-MM-") + (i < 10 ? "0" + i : i);
                            if (constructDate >= currentDate) {
                                dayConstuct.isActive = true
                            }
                        } else {
                            dayConstuct.isActive = true
                        }
                    }

                    if (this.keyMove.isShow && this.keyMove.month === 1 && this.keyMove.position == (i < 10 ? "0" + i : i)) {
                        dayConstuct.isFill = true;
                    }

                    if (this.hoverDayFirst && dayConstuct.isActive && this.selectedDate.length) {
                        if (this.hoverDayFirst.to === "all_right") {
                            if (i >= this.hoverDayFirst.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "right") {
                            if (i >= this.hoverDayFirst.day && i < +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "all_left") {
                            if (i <= this.hoverDayFirst.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "left") {
                            if (i <= this.hoverDayFirst.day && i > +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDayFirst.to === "all") {
                            dayConstuct.isFill = true
                        }
                    }
                    if (this.keyMove.month === 2) {
                        dayConstuct.isFill = false
                    }
                    res.push(dayConstuct)
                }
                return res
            },
            secondDaysCount() {
                let res         = [];
                let checkedDate = this.selectedDate.map(x => x.value);
                for (let i = 1; i <= moment(new Date(this.current)).add(1, 'M').daysInMonth(); i++) {
                    let dayConstuct = {
                        day: (i < 10 ? "0" + i : i),
                        isActive: false,
                        isChecked: false,
                        isFill: false,
                    }
                    if (checkedDate.includes(moment(new Date(this.current)).add(1, 'M').format("YYYY-MM-") + (i < 10 ? "0" + i : i))) {
                        dayConstuct.isChecked = true
                    }
                    if (this.activeDates.includes((i < 10 ? "0" + i : i) + moment(new Date(this.current)).add(1, 'M').format(".MM.YYYY")) || !this.activeDates.length) {
                        if (!this.activeDates.length) {
                            let currentDate   = moment(new Date()).format("YYYY-MM-DD");
                            let constructDate = moment(new Date(this.current)).add(1, 'M').format("YYYY-MM-") + (i < 10 ? "0" + i : i);
                            if (constructDate >= currentDate) {
                                dayConstuct.isActive = true
                            }
                        } else {
                            dayConstuct.isActive = true
                        }
                    }

                    if (this.hoverDaySecond && dayConstuct.isActive && this.selectedDate.length) {
                        if (this.hoverDaySecond.to === "all_right") {
                            if (i >= this.hoverDaySecond.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "right") {
                            if (i >= this.hoverDaySecond.day && i < +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "all_left") {
                            if (i <= this.hoverDaySecond.day) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "left") {
                            if (i <= this.hoverDaySecond.day && i > +this.selectedDate[0].value.split("-")[2]) {
                                dayConstuct.isFill = true
                            }
                        } else if (this.hoverDaySecond.to === "all") {
                            dayConstuct.isFill = true
                        }
                    }
                    res.push(dayConstuct)
                }
                return res
            },
        },
        methods: {
            openPicker() {
                if (!this.disabledData)
                    this.showPicker = true;
            },
            remove(key) {
                if (key === 0) {
                    this.firstDate.text = "";
                    this.firstDate.value = "";
                    this.secondDate.text = "";
                    this.secondDate.value = "";
                    this.selectedDate = []
                } else {
                    this.secondDate.text = "";
                    this.secondDate.value = "";
                    this.selectedDate = this.selectedDate.filter((x,i) => i === 0)
                }
            },
            calendarMounted() {
                this.daysChecked = window.settings.selectPlusMinusDayTicket;
                this.disabledData = this.disabled;

                const days = [1, 2, 3];
                this.daysCount = days.map(x => {
                    return {
                        label: x,
                        value: x
                    }
                });
                if (this.dayMode === 1 || this.dayMode === 2) {
                    this.daysCount = this.daysCount.map(x => {
                        x.value = x.value - 1;
                        x.label = x.label - 1;
                        return x
                    });
                }
                const selectedDay = window.settings.plusMinusDayCountTicket;
                this.selectedDay = days.includes(selectedDay) ? selectedDay : 1;

                let localCode = localStorage.getItem("localize") || document.getElementById('defaultLanguageCode').value;
                localCode = localCode === "ua" ? "uk" : localCode
                moment.locale(localCode);
                this.weeks = []
                for (let i = 1; i <= 7; i++) {
                    let day = "2020-06-" + `0${i}`;
                    let week = moment(day).format("ddd")
                    this.weeks.push(week)
                }

                this.firstMonthYear = this.dateFormat(this.current, "MMMM YYYY");
                this.firstMonthYearValue = this.dateFormat(this.current, "YYYY/MM/DD");
                this.secondMonthYear = moment(new Date(this.current)).add(1, 'M').format("MMMM YYYY");

                if (this.value.dates && this.value.dates.length) {

                    this.selectedDate = this.value.dates.map(x => {
                        let res = {
                            text: moment(new Date(this.correctDate(x))).format("DD MMM"),
                            value: this.correctDate(x)
                        }
                        return res
                    });

                    this.setValue();
                }

                this.dataDate = this.value
                this.setFirstDayInMonth()
            },
            keyDown(e) {
                if (!this.showPicker) {
                    return
                }
                /* TAB EVENT */
                if (e.keyCode === 9) {
                    this.closePicker()
                    this.$emit("press-tab", e)
                }
                if (this.selectShow) {
                    e.preventDefault()
                    return
                }
                /* MOVE CONTROLE */
                this.keyMove.month = 1;
                let monthCount     = moment(new Date(this.current)).daysInMonth();
                if (e.keyCode === 39 && this.keyMove.position < monthCount) {
                    this.keyMove.position++;
                    e.preventDefault()
                } else if (e.keyCode === 39){
                    this.sldeDate("right");
                    this.keyMove.position = 1;
                    this.keyMove.month = 1;
                    e.preventDefault()
                }
                if (e.keyCode === 37 && this.keyMove.position > 1) {
                    this.keyMove.position--;
                    e.preventDefault()
                } else if (e.keyCode === 37) {
                    this.sldeDate("left");
                    this.keyMove.month = 1;
                    let newMonthCount = moment(new Date(this.current)).daysInMonth();
                    this.keyMove.position = newMonthCount
                    e.preventDefault()
                }
                if (e.keyCode === 40) {
                    e.preventDefault()
                    if ((+this.keyMove.position + 7) <= monthCount) {
                        this.keyMove.position = +this.keyMove.position + 7;
                    }
                }
                if (e.keyCode === 38) {
                    e.preventDefault()
                    if ((+this.keyMove.position - 7) > 0) {
                        this.keyMove.position = +this.keyMove.position - 7;
                    }
                }
                let hoverItem = this.firstDaysCount.find(x => x.day == (this.keyMove.position < 10 ? "0" + this.keyMove.position : this.keyMove.position));
                if (hoverItem) {
                    this.hover(hoverItem, 1)
                }
                if (e.keyCode === 13) {
                    if (this.focusFirst) {
                        const value = this.$refs.firstInput.value;
                        let dateRu = moment(value).format("DD.MM.YYYY");
                        let dateTime = moment(value).format("YYYY/MM");
                        let dateDay = moment(value).format("DD");
                        dateTime = new Date(dateTime).getTime();

                        if(!this.activeDates.includes(dateRu))
                            return;

                        this.firstDate.text = moment(value).format("DD MMM, ddd");
                        this.firstDate.value = moment(value).format("YYYY/MM/DD");
                        const slide = () => {
                            let firstMonthYear = this.firstMonthYearValue.split("/");
                            firstMonthYear.pop();
                            firstMonthYear = new Date(firstMonthYear.join("/")).getTime();
                            if (dateTime !== firstMonthYear) {
                                if (dateTime > firstMonthYear) {
                                    this.sldeDate("right")
                                } else {
                                    this.sldeDate("left")
                                }
                                this.$nextTick(() => {
                                    slide()
                                })
                            } else {
                                let item = this.firstDaysCount.find(x => x.day == dateDay);
                                this.selectDay(item, false, 0);
                                this.$refs.firstInput.value = "";

                                const firstDate = new Date(this.firstDate.value).getTime();
                                const secondDate = new Date(this.secondDate.value).getTime();
                                if (firstDate > secondDate) {
                                    let date = {...this.firstDate};
                                    this.firstDate.text = this.secondDate.text;
                                    this.firstDate.value = this.secondDate.value;

                                    this.secondDate.text = date.text;
                                    this.secondDate.value = date.value;
                                }
                                return
                            }
                        };
                        slide();
                    } else if (this.focusSecond) {
                        const value = this.$refs.secondInput.value;
                        let dateRu = moment(value).format("DD.MM.YYYY");
                        let dateTime = moment(value).format("YYYY/MM");
                        let dateDay = moment(value).format("DD");
                        dateTime = new Date(dateTime).getTime();

                        if(!this.activeDates.includes(dateRu))
                            return;

                        this.secondDate.text = moment(value).format("DD MMM, ddd");
                        this.secondDate.value = moment(value).format("YYYY/MM/DD");
                        const slide = () => {
                            let firstMonthYear = this.firstMonthYearValue.split("/");
                            firstMonthYear.pop();
                            firstMonthYear = new Date(firstMonthYear.join("/")).getTime();
                            if (dateTime !== firstMonthYear) {
                                if (dateTime > firstMonthYear) {
                                    this.sldeDate("right")
                                } else {
                                    this.sldeDate("left")
                                }
                                this.$nextTick(() => {
                                    slide()
                                })
                            } else {
                                let item = this.firstDaysCount.find(x => x.day == dateDay);
                                this.selectDay(item, false, 1);
                                this.$refs.secondInput.value = "";

                                const firstDate = new Date(this.firstDate.value).getTime();
                                const secondDate = new Date(this.secondDate.value).getTime();
                                if (firstDate > secondDate) {
                                    let date = {...this.firstDate};
                                    this.firstDate.text = this.secondDate.text;
                                    this.firstDate.value = this.secondDate.value;

                                    this.secondDate.text = date.text;
                                    this.secondDate.value = date.value;
                                }
                                return
                            }
                        };
                        slide();
                    } else {
                        let item = this.firstDaysCount.find(x => {
                            return x.day == (this.keyMove.position.length < 2 ? "0" + this.keyMove.position : this.keyMove.position)
                        });
                        if (item) {
                            this.selectDay(item)
                        }
                    }
                }
            },
            keyUp() {
                if (!this.showPicker) {
                    return
                }
            },
            showPopover(text, e) {
                if (!this.selectedDate.length) {
                    let rect = e.target.getBoundingClientRect()
                    let res  = {
                        x: rect.left + (rect.width / 2),
                        y: rect.top,
                        text: text
                    }
                    this.$store.dispatch(typesGlobal.A_SHOW_POPOVER,res)
                }
            },
            correctDate(date) {
                let res = date.split(".").reverse().join("-")
                return res
            },
            click(e) {
                this.$emit("click", e)
            },
            isRound() {
                return "";
                // if (arr[key].isFill && arr[key - 1] && !arr[key - 1].isFill && arr[key + 1] && !arr[key + 1].isFill) {
                //     return "round-all"
                // }
                // if (arr[key].isFill && arr[key - 1] && !arr[key - 1].isFill) {
                //     return "round-left"
                // }
                // if(arr[key].isFill && arr[key + 1] && !arr[key + 1].isFill) {
                //     return "round-right"
                // }
            },
            setValue() {
                if (this.selectedDate.length) {
                    const dayMode    = (this.dayMode === 1 || this.dayMode === 2);
                    let daysLocalize = "";
                    const day        = this.selectedDay;

                    if (dayMode) {
                        daysLocalize = day === 1 ? this.localizeList.night : (day < 5 ? this.localizeList.night2 : this.localizeList.nights);
                    } else {
                        daysLocalize = day === 1 ? this.localizeList.day : (day < 5 ? this.localizeList.day2 : this.localizeList.days);
                    }

                    this.inputValue = this.selectedDate.length > 1 ? `${this.selectedDate[0].text} – ${this.selectedDate[this.selectedDate.length-1].text}` : this.selectedDate[0].text;
                    if (this.daysChecked && day) {
                        this.inputValue += ` | +/-${day} ${daysLocalize}`
                    }
                } else {
                    this.inputValue = ""
                }
            },
            done() {
                let inputData = {
                    dates: [],
                    days: this.daysChecked ? this.selectedDay : null
                };
                if (this.direct !== 'oneway' && this.firstDate.value.length && this.disabledDone || !this.firstDate.value.length) {
                    this.clear();
                    this.$emit("input", inputData);
                    return;
                }
                this.setValue();
                let first = this.firstDate.value;
                let second = this.secondDate.value;
                let dates = this.direct === "oneway" ? [first] : [first, second];

                inputData.dates = dates;
                this.$emit("input", inputData);
                if (this.showPicker) {
                    this.showPicker = false;
                }
                document.cookie = `ticketsDate=${JSON.stringify(inputData)}; path=/`;
                // localStorage.setItem("ticketsDate", JSON.stringify(inputData))
            },
            clear() {
                this.selectedDate = [];
                this.firstDate.text = "";
                this.firstDate.value = "";
                this.secondDate.text = "";
                this.secondDate.value = "";
                this.daysChecked = false;
                this.setValue()
            },
            removeSelectedDate(key) {
                this.selectedDate.splice(key, 1)
            },
            unHover() {
                this.hoverDayFirst  = null;
                this.hoverDaySecond = null;
                this.keyMove.isShow = true;
            },
            hover(item, month) {
                if (this.direct === "oneway")
                    return;

                if (item.isActive && this.selectedDate.length === 1) {
                    this.keyMove.isShow = false;
                    let hoverDate       = null;
                    if (month === 1) {
                        hoverDate = moment(new Date(this.current)).format("YYYY-MM") + "-" + item.day;
                        if (this.selectedDate[0].value > hoverDate) {
                            if (this.selectedDate[0].value.split("-")[0] > hoverDate.split("-")[0]) {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "all_right"
                                }
                                if (this.selectedDate[0].value.split("-")[1] > "01") {
                                    this.hoverDaySecond = {
                                        day: null,
                                        month: month + 1,
                                        to: "all"
                                    }
                                } else {
                                    this.hoverDaySecond = {
                                        day: this.selectedDate[0].value.split("-")[2],
                                        month: month + 1,
                                        to: "all_left"
                                    }
                                }
                            } else {
                                if (this.selectedDate[0].value.split("-")[1] > hoverDate.split("-")[1]) {
                                    this.hoverDayFirst = {
                                        day: item.day,
                                        month,
                                        to: "all_right"
                                    }
                                    if (this.selectedDate[0].value.split("-")[1] - 1 > hoverDate.split("-")[1]) {
                                        this.hoverDaySecond = {
                                            day: null,
                                            month: month + 1,
                                            to: "all"
                                        }
                                    } else {
                                        this.hoverDaySecond = {
                                            day: this.selectedDate[0].value.split("-")[2],
                                            month: month + 1,
                                            to: "all_left"
                                        }
                                    }
                                } else {
                                    this.hoverDayFirst = {
                                        day: item.day,
                                        month,
                                        to: "right"
                                    }
                                    this.hoverDaySecond = null;
                                }
                            }
                        } else {
                            this.hoverDaySecond = null;
                            if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1]) {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "all_left"
                                }
                            } else {
                                this.hoverDayFirst = {
                                    day: item.day,
                                    month,
                                    to: "left"
                                }
                            }
                        }
                    } else {
                        hoverDate = moment(new Date(this.current)).add(1, "M").format("YYYY-MM") + "-" + item.day;
                        if (this.selectedDate[0].value > hoverDate) {
                            if (this.selectedDate[0].value.split("-")[1] > hoverDate.split("-")[1]) {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "all_right"
                                }
                            } else {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "right"
                                }
                            }
                            this.hoverDayFirst = null;
                        } else {
                            if (this.selectedDate[0].value.split("-")[0] < hoverDate.split("-")[0]) {
                                this.hoverDaySecond = {
                                    day: item.day,
                                    month,
                                    to: "all_left"
                                }
                                if (hoverDate.split("-")[1] > "01") {
                                    this.hoverDayFirst = {
                                        day: null,
                                        month: 12,
                                        to: "all"
                                    }
                                } else {
                                    this.hoverDayFirst = {
                                        day: this.selectedDate[0].value.split("-")[2],
                                        month: 12,
                                        to: "all_right"
                                    }
                                }
                            } else {
                                if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1]) {
                                    this.hoverDaySecond = {
                                        day: item.day,
                                        month,
                                        to: "all_left"
                                    }
                                    if (this.selectedDate[0].value.split("-")[1] < hoverDate.split("-")[1] - 1) {
                                        this.hoverDayFirst = {
                                            day: null,
                                            month,
                                            to: "all"
                                        }
                                    } else {
                                        this.hoverDayFirst = {
                                            day: this.selectedDate[0].value.split("-")[2],
                                            month,
                                            to: "all_right"
                                        }
                                    }
                                } else {
                                    this.hoverDaySecond = {
                                        day: item.day,
                                        month,
                                        to: "left"
                                    }
                                    this.hoverDayFirst = null;
                                }
                            }
                        }
                    }
                } else {
                    this.unHover()
                }
            },
            selectDay(item, secondMonth = false, position = null) {

                if (item.isActive) {
                    let selectedDate = null;
                    if (secondMonth) {
                        selectedDate = moment(new Date(this.current)).add(1, 'M').format("YYYY/MM/") + item.day;
                    } else {
                        selectedDate = moment(new Date(this.current)).format("YYYY/MM/") + item.day;
                    }

                    if(position === null) {
                        if (this.secondDate.value.length && this.firstDate.value.length){
                            this.firstDate.text = moment(selectedDate).format("DD MMM, ddd");
                            this.firstDate.value = selectedDate;

                            this.secondDate.text = "";
                            this.secondDate.value = "";
                            this.selectedDate = [];
                            let date = {
                                value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                                text: moment(new Date(selectedDate)).format("DD MMM")
                            };
                            this.selectedDate.push(date);
                            return;
                        }
                        if(this.secondDate.value.length || !this.firstDate.value.length) {
                            this.firstDate.text = moment(selectedDate).format("DD MMM, ddd");
                            this.firstDate.value = selectedDate;

                            this.secondDate.text = "";
                            this.secondDate.value = "";
                            this.selectedDate = []
                        } else {
                            this.secondDate.text = moment(selectedDate).format("DD MMM, ddd");
                            this.secondDate.value = selectedDate;
                        }
                        const firstDate = new Date(this.firstDate.value).getTime();
                        const secondDate = new Date(this.secondDate.value).getTime();
                        if (firstDate > secondDate) {
                            let date = {...this.firstDate};
                            this.firstDate.text = this.secondDate.text;
                            this.firstDate.value = this.secondDate.value;

                            this.secondDate.text = date.text;
                            this.secondDate.value = date.value;
                        }
                    }
                    if (this.direct === "oneway") {
                        this.firstDate.text = moment(selectedDate).format("DD MMM, ddd");
                        this.firstDate.value = selectedDate;

                        this.selectedDate = [];
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        };
                        this.selectedDate.push(date);
                        return
                    }

                    if (!this.selectedDate.length) {
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        }
                        this.selectedDate.push(date)
                    } else if (this.selectedDate.length > 1) {
                        this.clear();
                        let date = {
                            value: moment(new Date(selectedDate)).format("YYYY-MM-DD"),
                            text: moment(new Date(selectedDate)).format("DD MMM")
                        }
                        this.selectedDate.push(date)
                    } else {
                        selectedDate = selectedDate.split("/").join("-");

                        let firstSelectedDate = this.selectedDate[0].value;
                        let firstDay          = +firstSelectedDate.split("-")[firstSelectedDate.split("-").length - 1];
                        let day               = +selectedDate.split("-")[selectedDate.split("-").length - 1];
                        let firstMonth        = +firstSelectedDate.split("-")[1];
                        let month             = +selectedDate.split("-")[1];
                        let firstYear         = +firstSelectedDate.split("-")[0];
                        let year              = +selectedDate.split("-")[0];

                        if (firstSelectedDate < selectedDate) {
                            if (firstYear < year) {
                                while (firstYear < year) {
                                    while (firstMonth <= 12) {
                                        firstDay         = firstMonth > +firstSelectedDate.split("-")[1] ? 1 : firstDay;
                                        let currentMonth = firstYear + `/${firstMonth}/1`;

                                        for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = firstSelectedDate.split("-")[0] + `/${firstMonth}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        firstMonth++
                                    }
                                    firstYear++
                                }
                                firstMonth = 1;
                                while (firstMonth < month) {
                                    firstDay = 1;
                                    let currentMonth = year + `/${firstMonth}/1`;

                                    for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                        i = i < 10 ? "0" + i : i;
                                        let date = year + `/${firstMonth}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                    firstMonth++
                                }
                                let i = 0;
                                while (i < day) {
                                    i++
                                    let date = year + `/${month}` + `/${i}`
                                    let dateObj = {
                                        value: moment(new Date(date)).format("YYYY-MM-DD"),
                                        text: moment(new Date(date)).format("DD MMM")
                                    }
                                    if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY"))) {
                                        this.selectedDate.push(dateObj)
                                    }
                                }
                            } else {
                                if (firstMonth < month) {
                                    while (firstMonth < month) {
                                        firstDay = firstMonth > +firstSelectedDate.split("-")[1] ? 1 : firstDay;
                                        let currentMonth = firstSelectedDate.split("-")[0] + `/${firstMonth}/1`;

                                        for (let i = firstDay; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = firstSelectedDate.split("-")[0] + `/${firstMonth}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        firstMonth++
                                    }
                                    let i = 0;
                                    while (i < day) {
                                        i++
                                        let date = firstSelectedDate.split("-")[0] + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                } else {
                                    while (firstDay < day) {
                                        firstDay++
                                        let date = firstSelectedDate.split("-").slice(0, -1).join("/") + `/${firstDay}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                }
                            }
                        } else if (firstSelectedDate > selectedDate) {
                            if (firstYear > year) {
                                while (firstYear > year) {
                                    while (month <= 12) {
                                        day = month > +selectedDate.split("-")[1] ? 1 : day;
                                        let currentMonth = year + `/${month}/1`;

                                        for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        month++
                                    }
                                    year++
                                }
                                month = 1;
                                while (month < firstMonth) {
                                    day              = 1;
                                    let currentMonth = year + `/${month}/1`;

                                    for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                        i = i < 10 ? "0" + i : i;
                                        let date = year + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                    month++
                                }
                                let i = 0;
                                while (i < firstDay) {
                                    i++
                                    let date    = year + `/${month}` + `/${i}`
                                    let dateObj = {
                                        value: moment(new Date(date)).format("YYYY-MM-DD"),
                                        text: moment(new Date(date)).format("DD MMM")
                                    }
                                    if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                        this.selectedDate.push(dateObj)
                                    }
                                }
                            } else {
                                if (month < firstMonth) {
                                    while (month < firstMonth) {
                                        day              = month > +selectedDate.split("-")[1] ? 1 : day;
                                        let currentMonth = selectedDate.split("-")[0] + `/${month}/1`;

                                        for (let i = day; i <= moment(new Date(currentMonth)).daysInMonth(); i++) {
                                            i = i < 10 ? "0" + i : i;
                                            let date    = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                            let dateObj = {
                                                value: moment(new Date(date)).format("YYYY-MM-DD"),
                                                text: moment(new Date(date)).format("DD MMM")
                                            }
                                            if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                                this.selectedDate.push(dateObj)
                                            }
                                        }
                                        month++
                                    }
                                    let i = 0;
                                    while (i < firstDay) {
                                        i++
                                        let date    = selectedDate.split("-")[0] + `/${month}` + `/${i}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                    }
                                } else {
                                    while (day < firstDay) {
                                        let date    = selectedDate.split("-").slice(0, -1).join("/") + `/${day}`
                                        let dateObj = {
                                            value: moment(new Date(date)).format("YYYY-MM-DD"),
                                            text: moment(new Date(date)).format("DD MMM")
                                        }
                                        if (!this.selectedDate.map(x => x.value).includes(dateObj.value) && (this.activeDates.includes(moment(new Date(date)).format("DD.MM.YYYY")) || !this.activeDates.length)) {
                                            this.selectedDate.push(dateObj)
                                        }
                                        day++
                                    }
                                }
                            }
                        } else {
                            let date = {
                                value: moment(selectedDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
                                text: moment(selectedDate, "YYYY-MM-DD").format("DD MMM")
                            }
                            this.selectedDate.push(date)
                        }
                    }
                    this.selectedDate = this.$store.getters['quicksort'](this.selectedDate, "value");
                    this.$emit("change", this.selectedDate.map(x => moment(x.value, "YYYY-MM-DD").format("DD.MM.YYYY")))
                }
            },
            dateFormat(date, format) {
                return moment(new Date(date)).format(format)
            },
            closePicker() {
                this.showPicker = false;
                //this.done();
                this.$store.dispatch(typesGlobal.A_SET_ALERT, 0)
            },
            setFirstDayInMonth() {
                if (!this.$refs.firstMonth || !this.$refs.secondMonth) {
                    return
                }
                const firstMonth = parseInt(moment(new Date(this.current)).startOf('month').format('E'));
                const secondMonth = parseInt(moment(new Date(this.current)).add(1, 'M').startOf('month').format('E'));

                this.$refs.firstMonth.childNodes[0].style.gridColumnStart  = firstMonth;
                this.$refs.secondMonth.childNodes[0].style.gridColumnStart = secondMonth;
            },
            sldeDate(to) {
                this.keyMove.month = 2;
                if (to === 'right') {
                    this.current = moment(new Date(this.current)).locale("ru").add(1, 'M')
                } else {
                    this.current = moment(new Date(this.current)).locale("ru").add(-1, 'M')
                }
            },
        },
        watch: {
            focusFromParent(val) {
                if (val) {
                    this.showPicker = true
                }
            },
            localizeList: {
                deep: true,
                handler() {
                    this.setValue()
                }
            },
            value: {
                deep: true,
                handler(val) {
                    if (!val || !Object.entries(val).length || !val.dates.length) {
                        this.clear();
                        this.setValue();
                    } else {
                        val.dates.forEach((x, i) => {

                            if (i === 0) {
                                this.firstDate.value = x;
                                this.firstDate.text = moment(x).format("DD MMM, ddd");
                            }
                            if (i === 1) {
                                this.secondDate.value = x;
                                this.secondDate.text = moment(x).format("DD MMM, ddd");
                            }
                        });
                        let start = this.firstDate.value;
                        let end = this.secondDate.value;
                        this.selectedDate = [];
                        if (start.length && end.length) {
                            start = new Date(start);
                            end = new Date(end);
                            while(start <= end){
                                let res = {
                                    text: moment(start).format("DD MMM"),
                                    value: moment(start).format("YYYY-MM-DD")
                                };
                                this.selectedDate.push(res);
                                let newDate = start.setDate(start.getDate() + 1);
                                start = new Date(newDate);
                            }
                        } else if (start.length) {
                            let res = {
                                text: moment(start).format("DD MMM"),
                                value: moment(start).format("YYYY-MM-DD")
                            };
                            this.selectedDate.push(res);
                        }

                        if (val.days !== null) {
                            this.daysChecked = true;
                            this.selectedDay = val.days
                        }
                        this.setValue();
                    }
                }
            },
            disabled(val) {
                this.disabledData = val
            },
            current(val) {
                this.firstMonthYear  = this.dateFormat(val, "MMMM YYYY");
                this.firstMonthYearValue = this.dateFormat(val, "YYYY/MM/DD");
                this.secondMonthYear = moment(new Date(val)).add(1, 'M').format("MMMM YYYY");
                this.setFirstDayInMonth()
            },
            "firstDate.value"(val) {
                if (val && val.length) {
                    if (this.direct !== "oneway" && !this.secondDate.value)
                        this.$emit("getActiveDate", val)
                } else {
                    this.$emit("getActiveDate")
                }
            },
            "secondDate.value"(val) {
                if (val && val.length) {
                    if (this.direct !== "oneway")
                        this.$emit("getActiveDate")
                } else if (this.firstDate.value) {
                    if (this.direct !== "oneway")
                        this.$emit("getActiveDate", this.firstDate.value)
                }
            },
            showPicker(val) {
                if (val) {
                    window.addEventListener('keydown', this.keyDown);
                    window.addEventListener('keyup', this.keyUp);
                    this.$emit("focus");
                } else {
                    this.done();
                    window.removeEventListener('keydown', this.keyDown);
                    window.removeEventListener('keyup', this.keyUp);
                    this.$emit("blur");
                }
            }
        }
    }
</script>

<style scoped>
    .calendar {
        position: relative;
    }

    .calendar .present-input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
    }

    .calendar input::placeholder {
        color: var(--lighten-5-color);
    }

    .calendar .calendar-icon {
        position: absolute;
        top: calc(50% - 10px);
        right: 11px;
    }

    .bg-effect {
        z-index: 100;
    }
    .calendar .date-picker {
        background-color: var(--white-color);
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
        z-index: 100;
    }
    .calendar .date-picker .date-header {
        padding: 19px 32px;
        border-bottom: 1px dashed #E0E0E0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 4px;
        align-items: center;
    }
    .calendar .date-picker .date-header.multy{
        display: flex;
    }
    .calendar .date-picker .date-header h3 {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #1D1D1D;
        margin-right: 13px;
        white-space: nowrap;
    }
    .calendar .date-picker .date-header .selected-date-wrap {
        display: flex;
        width: 100%;
    }
    .calendar .date-picker .date-header .selected-date {
        background: var(--green-color);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        height: 32px;
        margin: 0 4px 4px 0;
    }
    .calendar .date-picker .date-header .selected-date span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--white-color);
    }
    .calendar .date-picker .date-header .selected-date .close-icon {
        width: 9px;
        height: 9px;
        fill: var(--white-color);
        opacity: .7;
        margin-left: 3px;
        cursor: pointer;
    }
    .calendar .date-picker .date-body{
        padding: 16px 32px;
        border-bottom: 1px dashed #E0E0E0;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .calendar .date-picker .date-1{
        margin-right: 32px;
    }
    .calendar .date-body .date-slider{
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
    .calendar .date-body .date-2 .date-slider{
        justify-content: flex-end;
    }
    .calendar .date-body .date .date-month-year {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        text-transform: capitalize;
        color: var(--dark-2-color);
    }
    .calendar .date-body .date-1 .date-month-year{
        margin-left: calc(50% - 28px);
        transform: translateX(-50%)
    }
    .calendar .date-body .date-2 .date-month-year{
        margin-right: calc(50% - 28px);
        transform: translateX(50%)
    }
    .calendar .date-body .date-slider-btn{
        width:28px;
        height:28px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: var(--lighten-6-color);
        transition: all .2s;
        cursor: pointer;
    }
    .calendar .date-body .date-slider-cap{
        width:28px;
        height:28px;
    }
    .calendar .date-body .date-slider-btn:hover{
        background-color: #e0e0e0;
    }
    .calendar .date-body .date-slider-btn svg{
        fill: var(--dark-1-color);
    }
    .calendar .date-body .date-2 .date-slider-btn {
        transform: rotate(180deg)
    }
    .calendar .date-body .date-weeks {
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .calendar .date-body .date-weeks span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--lighten-7-color);
    }
    .calendar .date-body .date-weeks span:nth-last-child(1),
    .calendar .date-body .date-weeks span:nth-last-child(2) {
        color: var(--green-5-color);
    }
    .calendar .date-body .date-month {
        width: 280px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-row-gap: 2px;
    }
    .calendar .date-body .date-month .date-day {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content:center;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--lighten-5-color);
        transition: all .2s;
    }
    .calendar .date-body .date-month .date-day.fill {
        background-color: var(--green-color);
        color: rgba(255, 255, 255, .5);
    }
    .calendar .date-body .date-month .date-day.round-all {
        border-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.round-left {
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.round-right{
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
    }
    .calendar .date-body .date-month .date-day.active {
        background-color: var(--green-3-color);
        color: #1D1D1D;
        cursor: pointer;
    }
    .calendar .date-body .date-month .date-day.active.fill {
        background-color: var(--green-4-color);
        color: var(--white-color);
    }
    .calendar .date-body .date-month .date-day.active:hover {
        background-color: var(--green-4-color);
        color: var(--white-color);
    }
    .calendar .date-body .date-month .date-day.checked {
        background-color: var(--green-2-color);
        color: var(--white-color);
        cursor: pointer;
    }
    .calendar .date-body .date-month .date-day.checked:hover {
        background-color: var(--green-4-color);
    }
    .calendar .date-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 32px;
    }
    .calendar .date-footer .title {
        font-weight: bold;
        font-size: 15px;
        line-height: 18px;
        white-space: nowrap;
    }
    .calendar .date-footer .title{
        color: var(--dark-2-color);
    }
    .calendar .date-footer .grey-text {
        color: #828282;
    }
    .calendar .date-footer /deep/.select {
        min-height: 36px;
    }
    .calendar .alert-not-show {
        display: inline-block;
    }

    .input-wrap {
        position: relative;
        width: 100%;
        padding: 12px 40px 12px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        cursor: text;
    }
    .input-wrap.focus {
        border: 2px solid var(--primary-color);
        background-color: var(--white-color);
        padding: 10px 38px 10px 10px;
    }
    .input-wrap input {
        width: 50%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
        background-color: transparent;
    }
    .input-wrap input::placeholder {
        font-weight: 500;
        font-size: 16px;
        color: #717171;
    }
    .input-wrap .selected-text {
        font-weight: 500;
        font-size: 15px;
        color: #333;
    }
    .input-wrap .clear-icon {
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #9f9f9f;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        cursor: pointer;
    }
    .input-wrap .clear-icon::before,
    .input-wrap .clear-icon::after {
        content: "";
        width: 12px;
        height: 2px;
        background-color: var(--white-color);
        display: block;
        position: absolute;
        left: 3px;
        top: calc(50% - 1px);
        border-radius: 2px;
    }
    .input-wrap .clear-icon::before {
        transform: rotate(45deg);
    }
    .input-wrap .clear-icon::after {
        transform: rotate(-45deg);
    }
</style>
